export default {"src":"/_next/static/media/search2.ddfb7d95.svg","height":622,"width":578};